import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=10508712&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=10508712&prod&scoped=true&lang=css"
import style1 from "./Participants.vue?vue&type=style&index=1&id=10508712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10508712",
  null
  
)

export default component.exports